export default "__VITE_ASSET__BVoohogO__"